import React, { memo } from "react";
import { styled } from "@mui/system";
import { Box, Button, Chip, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const GradientCard = styled(motion.div)(({}) => ({
  backgroundImage: "linear-gradient(to right, #A125C2,#0089D0)",
  padding: "20px",
  borderRadius: "15px",
  cursor: "pointer",
  display: "flex",
  position: "relative",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
  },
  minHeight: 120,
}));

const CompanyCard = memo(({ count, color, icon, title }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <GradientCard
        initial={{ y: -200, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            gap: 1,
          }}
        >
          <Icon
            icon="fluent-color:building-multiple-20"
            width={40}
            height={40}
          />
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 700,
              color: "#fff",
            }}
          >
            Interval Learning - Company Overview
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: 40,
            fontWeight: 700,
            color: "#fff",
          }}
        >
          78%
        </Typography>
        <Typography
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            mb: 1,
          }}
        >
          Overall MUEI Score
        </Typography>
        <Box
          sx={{
            backgroundColor: "#fff",
            padding: "5px 10px",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#A125C2",
          }}
        >
          Balanced
        </Box>
      </GradientCard>
    </Box>
  );
});

export default CompanyCard;
